import React from "react"
import { SvgIcon, type SvgIconProps } from "@mui/material"

function RadioUncheckedRoundIcon(props: SvgIconProps) {
  return (
    <SvgIcon
      width="22"
      height="22"
      viewBox="0 0 22 22"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <circle cx="11" cy="11" r="10.5" fill="white" stroke="#F0F0F0" />
    </SvgIcon>
  )
}

export default RadioUncheckedRoundIcon